export const jobPositions = [
  'administration',
  'backendDeveloper',
  'businessAnalyst',
  'businessDeveloper',
  'contentDesigner',
  'contentProducer',
  'dataEngineer',
  'dataScientist',
  'departmentDirector',
  'designLead',
  'director',
  'frontendDeveloper',
  'fullStackDeveloper',
  'graphicDesigner',
  'hardwareDeveloper',
  'hr',
  'humanResourcesManager',
  'informationArchitect',
  'interactionDesigner',
  'itCustodian',
  'legalAdvisor',
  'mobileDeveloper',
  'organizationDeveloper',
  'principalEngineer',
  'productOwner',
  'securityExpert',
  'serviceDesigner',
  'storyteller',
  'teamLead',
  'techLead',
  'other',
];

export const possibleDevelopers = [
  'frontendDeveloper',
  'backendDeveloper',
  'fullStackDeveloper',
  'dataScientist',
  'dataEngineer',
  'hardwareDeveloper',
  'mobileDeveloper',
];

export const possibleDesigners = [
  'interactionDesigner',
  'serviceDesigner',
  'contentDesigner',
  'graphicDesigner',
  'contentProducer',
];

export const possibleAdm = ['humanResourcesManager', 'administration', 'hr'];

export const displayOrder = [
  'director',
  'departmentDirector',
  'productOwner',
  'teamLead',
  'techLead',
  'designLead',
  'designers',
  'developers',
  'administration',
  'others'];
